import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';


@Component({
  selector: 'app-gelios-form-error',
  templateUrl: './gelios-form-error.component.html'
})
export class GeliosFormErrorComponent implements OnInit{
  @Input() formGroup: FormGroup;
  @Input() messages: {[message: string]: string} = {
    required: 'Required field',
    email: 'Invalid e-mail address',
    mustMatch: 'Fields must match',
  };
  protected field: AbstractControl;
  public messageKeys: Array<string>;
  public ngOnInit() {
    this.messageKeys = Object.keys(this.messages);
  }
}
